<template>
  <div
    class="chart-container"
    :class="{
      'chart-container--condensed': isFullComparisonScreen || isFullBaseScreen
    }"
  >
    <div class="chart-container__header">
      <h3 v-if="title">{{ title }}</h3>
      <slot />
    </div>
    <p v-if="description" class="mb-0">
      {{ description }}
    </p>

    <div
      class="chart-row"
      :class="{
        'chart-row--spacing': showRowSpacing
      }"
    >
      <ReviewsCategoriesHeatmapChart
        v-for="(chart, index) in charts"
        :key="chart.id"
        v-show="chart.show"
        v-bind="chart.props"
        @toggle-fullscreen="toggleFullScreen(index)"
      />
    </div>
  </div>
</template>

<script>
import ReviewsCategoriesHeatmapChart from "@/components/Reviews/Categories/ReviewsCategoriesHeatmapChart.vue";
import TinyGradient from "tinygradient";
import { mapGetters } from "vuex";

export default {
  name: "ReviewsCategoriesHeatmap",
  components: {
    ReviewsCategoriesHeatmapChart
  },
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isFullBaseScreen: false,
      isFullComparisonScreen: false,
      colorsRgb: null,
      color: []
    };
  },
  computed: {
    ...mapGetters("reviewsCategoriesAnalytics", {
      comparisonDate: "getComparisonDate",
      selectedDate: "getSelectedDate",
      isComparing: "isComparing"
    }),
    basicData() {
      return this.data.basic;
    },
    comparisonData() {
      return this.data.comparison;
    },
    isLoading() {
      return this.data.isLoading;
    },
    showRowSpacing() {
      return (
        this.comparisonData.length &&
        !(this.isFullComparisonScreen || this.isFullBaseScreen)
      );
    },
    getChartCommonAttributes() {
      return {
        isLoading: this.isLoading,
        color: this.color,
        isComparison: !!this.comparisonDate
      };
    },
    chartAttributes() {
      return [
        {
          id: "chart",
          show: !this.isFullComparisonScreen,
          props: {
            ...this.getChartCommonAttributes,
            id: "chart",
            date: this.selectedDate,
            data: this.basicData,
            isPrimary: true
          }
        },
        {
          id: "chartComparison",
          show: this.isComparing && !this.isFullBaseScreen,
          props: {
            ...this.getChartCommonAttributes,
            id: "chartComparison",
            date: this.comparisonDate,
            data: this.comparisonData
          }
        }
      ];
    },
    charts() {
      return this.comparisonDate
        ? this.chartAttributes
        : [this.chartAttributes[0]];
    }
  },
  created() {
    const gradient = TinyGradient([
      { color: "#FF316E", pos: 0 },
      { color: "#E5AD35", pos: 0.48 },
      { color: "#DBDA1F", pos: 0.49 },
      { color: "#DBDA1F", pos: 0.51 },
      { color: "#C5D727", pos: 0.52 },
      { color: "#29C15B", pos: 1 }
    ]);
    const colorsRgb = gradient.rgb(201);
    colorsRgb.forEach(e => {
      this.color.push(e.toHexString());
    });
  },
  methods: {
    toggleFullScreen(index) {
      if (index === 0) {
        this.isFullBaseScreen = !this.isFullBaseScreen;
      } else if (index === 1) {
        this.isFullComparisonScreen = !this.isFullComparisonScreen;
      }
      this.$emit("toggle-fullscreen");
    }
  }
};
</script>
<style lang="scss" scoped>
.chart-row {
  display: flex;
  justify-content: space-between;

  &--spacing {
    > * {
      &:first-child {
        margin-right: $spacing * 2;
      }
      &:last-child {
        margin-left: $spacing * 2;
      }
    }
  }
}

.chart-container {
  margin-top: $spacing * 10;

  &__header {
    margin-bottom: $spacing * 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: $spacing * 3;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
  }

  &--condensed {
    margin-top: $spacing * 4;
  }
}
</style>
